<template>
  <ClaimsLanding
    :start-claim-img="startClaimImg"
    :is-mobile="isMobile"
    :can-show-ev-claim="canShowEvClaim"
    can-show-history
    @start:claim="goToClaimsNew"
    @view:history="goToClaimsHistory"
  />
</template>

<script>
import { getAsset } from 'ecx.saigon.ui.common';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ClaimsLandingWidget',
  data() {
    return {
      startClaimImg: undefined
    };
  },
  computed: {
    ...mapState({
      hasLeases: (state) => state.lease.hasLeases,
      leases: (state) => state.lease.leases
    }),
    ...mapGetters('lease', ['evVehicleLeases']),
    isMobile() {
      return this.$q.screen.xs;
    },
    canShowEvClaim() {
      return Boolean(this.evVehicleLeases.length);
    }
  },
  methods: {
    goToClaimsHistory() {
      this.$router.push({
        name: this.$RouteNames.claims
      });
    },
    goToClaimsNew() {
      this.$router.push({
        name: this.$RouteNames.claimsNew
      });
    }
  },
  async mounted() {
    if (!this.hasLeases || !this.leases.length) {
      return this.$router.push({
        name: this.$RouteNames.dashboard
      });
    }

    // Claims landing will only display for mobile screens. The start claims UI is shown
    // in the history page for desktop screens
    if (!this.isMobile) {
      return this.goToClaimsHistory();
    }

    this.startClaimImg = await getAsset(this.$Constants.CLAIM_START_IMG_PATH);
  },
  components: {
    ClaimsLanding: () => import('../../components/page/claims-landing')
  }
};
</script>
